"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMinAvgMax = exports.getAvg = exports.getStocksValues = exports.stockIndexList = exports.StockIndexEnum = void 0;
var axios_1 = __importDefault(require("axios"));
var StockIndexEnum;
(function (StockIndexEnum) {
    StockIndexEnum["GSPC"] = "GSPC";
    StockIndexEnum["SP500TR"] = "SP500TR";
    StockIndexEnum["INIDA"] = "INIDA";
})(StockIndexEnum = exports.StockIndexEnum || (exports.StockIndexEnum = {}));
exports.stockIndexList = Object.values(StockIndexEnum);
var getStocksValues = function () { return __awaiter(void 0, void 0, void 0, function () {
    var baseRequest, APIKey, requestPeriod, requestBody, request, res, stockIndexValues;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                baseRequest = 'https://api.twelvedata.com';
                APIKey = '1b0d2ef4267d47aba911dddae838c0ee';
                requestPeriod = '&start_date=1970-01-01%2000:00:00&end_date=2070-01-01%2000:00:00';
                requestBody = "time_series?symbol=" + exports.stockIndexList.join(",") + "&type=Index&interval=1day" + requestPeriod;
                request = baseRequest + "/" + requestBody + "&apikey=" + APIKey;
                return [4 /*yield*/, axios_1.default.get(request)];
            case 1:
                res = _a.sent();
                console.log("Request twelvestocks", res);
                stockIndexValues = {};
                exports.stockIndexList.forEach(function (idx) {
                    if (res.data[idx] && res.data[idx].values) {
                        stockIndexValues[idx] = res.data[idx].values.map(function (v) { return parseFloat(v.open); }).reverse();
                    }
                });
                return [2 /*return*/, stockIndexValues];
        }
    });
}); };
exports.getStocksValues = getStocksValues;
var evolutionRate = function (a, b) { return (b - a) / a * 100; };
var getAvg = function (values, n, granularity) {
    if (granularity === void 0) { granularity = 20.95; }
    if (!values)
        return 0;
    var avg;
    var total = 0;
    var end = values.length - (n * granularity);
    if (end > 0) {
        for (var i = 0; i < end; i++) {
            total += evolutionRate(values[i], values[i + n]);
        }
        avg = total / values.length;
    }
    else
        avg = evolutionRate(values[0], values[values.length - 1]);
    return avg;
};
exports.getAvg = getAvg;
var getMin = function (values, n) {
    if (!values)
        return 0;
    var min;
    var end = values.length - n * 20.95;
    if (end > 0)
        for (var i = 0; i < end; i++) {
            min = Math.min(min || Infinity, evolutionRate(values[i], values[i + n]));
        }
    else
        min = evolutionRate(values[0], values[values.length - 1]);
    return min;
};
var getMax = function (values, n) {
    if (!values)
        return 0;
    var max;
    var end = values.length - n * 20.95;
    if (end > 0)
        for (var i = 0; i < end; i++) {
            max = Math.max(max || -Infinity, evolutionRate(values[i], values[i + n]));
        }
    else
        max = evolutionRate(values[0], values[values.length - 1]);
    return max;
};
var getMinAvgMax = function (stockIndexValues, n) {
    var res = {};
    exports.stockIndexList.forEach(function (idx) {
        if (stockIndexValues[idx] !== undefined) {
            res[idx] = {
                min: getMin(stockIndexValues[idx], n),
                avg: exports.getAvg(stockIndexValues[idx], n),
                max: getMax(stockIndexValues[idx], n),
            };
        }
    });
    return res;
};
exports.getMinAvgMax = getMinAvgMax;
